import { render, staticRenderFns } from "./EnablingFarmer.vue?vue&type=template&id=2de72d78&scoped=true&"
import script from "./EnablingFarmer.vue?vue&type=script&lang=js&"
export * from "./EnablingFarmer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de72d78",
  null
  
)

export default component.exports